import React, { useEffect, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { connect } from "react-redux";
import { useRouter } from "next/router";

import { getHost } from "common/helper";
import { addOverlay, removeOverlay } from "utils";

import AdminBrokerPageProto from "components/AdminBrokerPageProto";
import CustomLink from "components/CustomLink";
import Close from "components/Close";

import { selectTipsterOwnId, selectUserDetails } from "store/user/account/selectors";

import { useFormattedMessage } from "hooks";
import { inviteTitle } from "i18n/messages/accountMenu";

const HOST = getHost();

const SideModal = React.forwardRef((props, ref) => {
    const { tipsterOwnID = "", brokerName = "", open, onCloseButtonClick } = props;

    const LinkCopy = ({ link, text }) => {
        const [isCopied, setIsCopied] = useState(false);
        return (
            <>
                <CopyToClipboard text={link} onCopy={() => setIsCopied(true)}>
                    <button className="secondary">{link}</button>
                </CopyToClipboard>
                <CopyToClipboard text={link} onCopy={() => setIsCopied(true)}>
                    <button className="secondary">
                        <i className="fas fa-link" />
                        {text}
                        {isCopied ? " kopiert!" : " kopieren"}
                    </button>
                </CopyToClipboard>
            </>
        );
    };

    return (
        <div ref={ref} className={`side-modal editable-modal shadow${open ? " opened scroll-hidden" : " closed"}`}>
            <div className="close-container d-flex justify-between align-center">
                <div className="d-flex align-center">
                    <Close className="close-button fw-600" onCloseButtonClick={onCloseButtonClick} />
                    {/* <h4 className="modal-title my-0">Jetzt einladen</h4> */}
                </div>
            </div>
            <div className="side-modal-wrap flex">
                <div className="modal-body">
                    <div className="side-modal-container partner-modal-container">
                        <div className="content-row">
                            <h4>Teilen Sie Ihren persönlichen Link mit ihrem Netzwerk</h4>
                            <p className="body-medium">Teilen Sie Ihren persönlichen Link mit Ihren Kunden.</p>
                            <LinkCopy link={`${HOST}?tipster=${tipsterOwnID}`} text="Link" />
                        </div>
                        <div className="content-row">
                            <h4>Über Social Media einladen</h4>
                            <p className="body-medium">Teilen Sie einen Beitrag mit Ihrem persönlichen Link in Social Media.</p>
                            <CustomLink
                                isExternal
                                url={`https://www.facebook.com/sharer/sharer.php?u=${HOST}?tipster=${tipsterOwnID}`}
                            >
                                <button className="facebook">
                                    <i className="fab fa-facebook-f" /> via Facebook
                                </button>
                            </CustomLink>
                            <CustomLink
                                isExternal
                                url={`https://www.linkedin.com/shareArticle?url=${HOST}?tipster=${tipsterOwnID}`}
                            >
                                <button className="linkedin">
                                    <i className="fab fa-linkedin-in" /> via LinkedIn
                                </button>
                            </CustomLink>
                        </div>
                        <div className="content-row">
                            <h4>Senden Sie eine Einladungsmail mit Ihrem persönlichen Link an Ihr Netzwerk</h4>
                            <p className="body-medium">
                                Senden Sie eine Einladungsmail mit Ihrem persönlichen Link an Ihre Kunden.
                            </p>
                            <a
                                href={`mailto:?subject=Kennnst Du schon FINEXITY?&body=Liebe/r Interessent*in,%0D%0A%0D%0Akennen Sie schon FINEXITY? - Deutschlands erste und führende Plattform für digitale Sachwertinvestitionen. FINEXITY bietet über seine Blockchain-basierte Investmentplattform eine Vielfalt an digitalen Sachwerten für Privatanleger an.%0D%0A%0D%0AGanz bestimmt ist auch für Sie die passende Anlageform mit dabei. Die Rede ist von Immobilienprojekten, Kunstwerken oder Old- und Youngtimern. Und das Besondere daran? Sie können bereits ab 500 EUR zu 100%25 digital innerhalb von 3 Minuten investieren und schon mit kleinen Beträgen von den Annehmlichkeiten somit zum Beispiel eines Immobilieninvestors profitieren!%0D%0A%0D%0ASchon 6.000 Kund*innen konnte FINEXITY bereits überzeugen. Seien Sie die/der Nächste und registrieren Sie sich jetzt unter: ${HOST}?tipster=${tipsterOwnID}%0D%0A%0D%0AMöchten Sie mehr über FINEXITY oder aktuelle Investmentmöglichkeiten erfahren, wenden Sie sich gern direkt an mich oder an das FINEXITY Team unter +49 40 822 177 20 oder über support@finexity.com.%0D%0A%0D%0AHerzliche Grüße%0D%0A%0D%0AIhr ${brokerName}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <button className="secondary">Einladungsmail versenden</button>
                            </a>
                        </div>
                        <div className="content-row">
                            <h4>Per Code:</h4>
                            <p>Ihr persönlicher Tippgeber-Code lautet:</p>
                            <LinkCopy link={tipsterOwnID} text="Code" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

const PartnerHeading = ({ title, onClick }) => {
    return (
        <div className="flex justify-center partner-heading">
            <button className="medium w-100 mb-0" onClick={onClick}>
                {title}
            </button>
        </div>
    );
};

const BrokerContainer = ({ tipsterOwnID, brokerName, children, headTitle, className, menu = "broker" }) => {
    const router = useRouter();
    const { formatMessage } = useFormattedMessage();

    const [openSideModal, setOpenSideModal] = useState(false);

    useEffect(() => {
        if (router.query && router.query.goto === "inviteCustomer") {
            jQuery(".broker-page .partner-heading button").click();
        }
    }, []);

    const changeRoute = () => {
        if (router.query && router.query.goto === "inviteCustomer") {
            router.push(router.pathname, undefined, { shallow: true });
        }
    };

    return (
        <AdminBrokerPageProto headTitle={headTitle} menu={menu} className={`broker-page permanent ${className}`}>
            <SideModal
                open={openSideModal}
                tipsterOwnID={tipsterOwnID}
                brokerName={brokerName}
                onCloseButtonClick={() => {
                    setOpenSideModal(false);
                    removeOverlay();
                    changeRoute();
                }}
            />
            <PartnerHeading
                title={formatMessage(inviteTitle)}
                // tipsterOwnID={tipsterOwnID}
                onClick={() => {
                    setOpenSideModal(true);
                    addOverlay();
                }}
            />
            {children}
        </AdminBrokerPageProto>
    );
};

export default connect((state) => ({
    tipsterOwnID: selectTipsterOwnId(state),
    brokerName: selectUserDetails(state) && `${selectUserDetails(state).FirstName} ${selectUserDetails(state).LastName}`,
}))(BrokerContainer);
